export default class ApiKeysManager {
    constructor(api) {
        this.api = api;
    }

    getApiKey = (id) => this.api.getApiKey(id);
    getApiKeys = () => this.api.getApiKeys();
    getMapKeys = () => this.api.getMapKeys();
    createApiKey = (values) => this.api.createApiKey(values);
    deleteApiKey = (id) => this.api.deleteApiKey(id);
    updateApiKey = (id, values) => this.api.updateApiKey(id, values);
    getApiUsagePlans = () => this.api.getApiUsagePlans();
    getApiKeyExternalProviders = () => this.api.getApiKeyExternalProviders();
    createFtpUser = () => this.api.createFtpUser();
    getFtpUser = () => this.api.getFtpUser();
    deleteFtpUser = () => this.api.deleteFtpUser();
}
